export enum FormStage {
  Dates = 'assignment',
  Grouping = 'grouping',
  PeerReviews = 'peerReviews',
  Grading = 'grading',
}
